module.exports = __webpack_public_path__ + "static/img/ntby.ee3a819.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ntby.png
// module id = WoIU
// module chunks = 0